import { Box, AppBar, Toolbar, Button, Typography, Stack, Dialog, DialogTitle, IconButton, DialogContent, Badge } from '@mui/material'
import React, { useState } from 'react'
import Logo from '../../newTestPreo/components/logo/Logo'
import { Link } from 'react-router-dom'
import AccountPopover from '../../components2/header/AccountPopover';
import { useCartContext } from '../../context/cart/cart_context';
import { useSidebarContext } from '../../context/sidebar/sidebar_context';
import { useSelector } from 'react-redux';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CallIcon from '@mui/icons-material/Call';
import RequestCallBack from '../pages/RequestCallBack';
import { Close } from '@mui/icons-material';

function AppBarComponent() {
    const {total_items,  cart: cartItems,
 
      total_amount,
      clearCart,} = useCartContext();
  const {openSidebar} = useSidebarContext();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const firstName  = localStorage.getItem('firstName');
  const {
  
  } = useCartContext();

    const buttonStyle = {
        backgroundColor: '#019e6f',
        borderRadius: '20px',
        fontFamily: 'Inters-Regular, Helvetica',
        fontSize: '16px',
        fontWeight: 400,
        
      };

      const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
    <Box sx={{ flexGrow: 1 }}>
  <AppBar position="fixed"  sx={{ bgcolor: "white" }}>
    <Toolbar>
      <Box>
        <Logo />
      </Box>
      
      <Box display='flex' marginLeft='auto'>
      <Link to='/'>
      <Button
        variant='contained'
        style={buttonStyle}
      >
        Home
      </Button>
      </Link>
        <Box m={2} />
        <Link to='/allclasses'>
        <Button
     variant='contained'
      style={buttonStyle}
    >
  Classes
</Button>
</Link>
        <Box m={2} />

        <Button
     variant='contained'
      style={buttonStyle}
      onClick={handleOpen}
    >
      <CallIcon style={{ marginRight: '5px' }} />
      Request Call Back
    </Button>

<Box m={1} />
        
       {/*} <Link to='/center-registration'>
          <Button variant='contained' style={buttonStyle}>Register</Button>
        </Link>
        <Box m={2} />
        <Link to='/login'>
          <Button variant='contained' style={buttonStyle}>Login</Button>
    </Link>*/}
      </Box>

      <Stack direction="row" sx={{ display: { xs: 'none', sm: 'block' } }} spacing={{ xs: 1.5, md: 2.5 }}>
          <div className='navbar-btns flex'>
            
            {isAuthenticated || firstName ? (
              <>

            <Link to='/studentdashboard'>
            <Button
              variant='contained'
              style={buttonStyle}
            >
              My Dashboard
            </Button>
            </Link>

            <Box m={2} />

            <Link to = "/checkout" className='cart-btn'>
            <Badge badgeContent={cartItems.length} color="error">
            <ShoppingCartIcon color='warning' fontSize='large' />
</Badge>
        
           
            </Link>

              <AccountPopover />
              </>
            ) : (
                
                <Link to='/login'>
                <Button variant='contained' style={buttonStyle}>Login</Button>
              </Link>
            )}
           {/*} <Button size='large' type = "button" className='sidebar-open-btn' onClick={() => openSidebar()}>
              <MdMenu size='large' color='success'/>
            </Button> */}
          </div>
          </Stack>
    </Toolbar>
  </AppBar>
</Box>

          <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          sx={{
            borderRadius: '10px', // Add border radius
            border: '2px solid #4CAF50', // Add green border
          }}
          >
            <DialogTitle variant='h4'>
            Request CallBack
            <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', top: 0, right: 0 }}>
              <Close />
            </IconButton>
          </DialogTitle>
            <DialogContent>
              <RequestCallBack onClose={handleClose} />
            </DialogContent>
          </Dialog>
          </>
  )
}

export default AppBarComponent